import axios from 'axios';
import { useEffect, useState, useRef } from 'react';
import { API_URL, ENDPOINTS } from '../../constants/api';
import { getToken,decodeToken } from '../../utils/TokenUtils';
import { useNavigate } from 'react-router-dom';

const OrderPanel = ({ items, setItems, onUpdateQty }) => {
  const token = getToken();
  const formRef = useRef(null);
  const vatRate = 0.05;
  const navigate = useNavigate();
  const [paid, setPaid] = useState(0);
  const [discountPercantage, setDiscountPercantage] = useState(0);
  const [customerQuery, setCustomerQuery] = useState('');
  const [matchedCustomers, setMatchedCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [deliveryMen, setDeliveryMen] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [newCustomer, setNewCustomer] = useState({ name: '', phone: '',email:'' });
  const [withVat, setWithVat] = useState(true);

  const [formData, setFormData] = useState({
    payment_tell: '',
    delivery_address: '',
    delivery_id: '',
    delivery_fee: '',
    order_status: '0',
  });

  const subTotal = items.reduce((acc, item) => acc + item.Price * item.qty, 0);
  const vat = withVat ? subTotal * vatRate : 0;
  const delivery_fee = parseFloat(formData.delivery_fee) || 0;
  const total = subTotal + vat + (delivery_fee>=0?delivery_fee :0.00);
  const discountAmount=total*discountPercantage;
  const user_id=decodeToken(token,'id');
  const clearCart = () => setItems([]);
  
  const handleOpenModal=()=>{
    setNewCustomer({email:'',name:'',phone:customerQuery});
    setShowModal(true)
  }
 const handleSave = async (isprint) => {
  try {
    let delivery_id;
    if (formData.delivery_id=='%') {
      delivery_fee=null;
    }else{
      delivery_id=formData.delivery_id
    }
    const tell = formData.payment_tell;
    const payment_tell = tell.slice(-9);

    const payload = {
      "customer_id": selectedCustomer?.id || null,
      "product_id": items.map(item => item.ID).join(','),
      "quantity": items.map(item => item.qty).join(','),
      "price": items.map(item => item.Price).join(','),
      "delivery_id": delivery_id,
      "delivery_address":formData.delivery_address || '',
      "delivery_fee": parseFloat(formData.delivery_fee) || 0,
      "total":total,
      "order_status": formData.order_status,
      "vat":vat,
      "discount": discountAmount,
      evc_payment_tell:payment_tell,
      "evc_description":"Food Order",
      "evc_amount":(total-discountAmount),
      "evc_status":"",
      "evc_response":"",
      "user_id":user_id
    };
    
    // alert(JSON.stringify(payload))
    const res=await axios.post(`${API_URL}/${ENDPOINTS.SYS}/create/register-pos_order`, payload, {
      headers: { Authorization: token ? `Bearer ${token}` : '' },
    });
    console.log("submit res: ",res.data);
    alert(res.data.message);

    if (res.data.success==1 && isprint) {
      const order_id=res.data.insertId;
      navigate(`/pos-invoice/pos-invoice/${order_id}`);
      handleCancel()

    }else if (res.data.success==1 && !isprint) {
      window.location.href = '/pos';
    }
    // handleCancel();
  } catch (error) {
    // console.error('Failed to save order:', error);
    // alert('Failed to save order');
  }
};


  useEffect(() => {
    const fetchDeliveryMen = async () => {
      try {
        const response = await axios.get(`${API_URL}/${ENDPOINTS.SYS}/get-dropdown/4154`, {
          headers: { Authorization: token ? `Bearer ${token}` : '' },
        });
        setDeliveryMen(response.data || []);
      } catch (error) {
        console.error('Failed to fetch delivery men:', error);
        setDeliveryMen([]);
      }
    };

    const fetchDiscount = async () => {
      try {
        const response = await axios.get(`${API_URL}/${ENDPOINTS.SYS}/getlink/pos_sales_discount-report`, {
          headers: { Authorization: token ? `Bearer ${token}` : '' },
        });
        setDiscountPercantage((response.data.report[0].discount/100) || 0);
      } catch (error) {
        console.error('Failed to discount:', error);
        setDiscountPercantage(0);
      }
    };
    
    fetchDiscount();
    fetchDeliveryMen();
    console.log("Discount: ",discountPercantage)
  }, []);

  useEffect(() => {
    const fetchCustomer = async () => {
      if (/^\d{5,}$/.test(customerQuery)) {
        try {
          const response = await axios.get(
            `${API_URL}/${ENDPOINTS.SYS}/autocomplete/4191?query=${customerQuery}`,
            {
              headers: { Authorization: token ? `Bearer ${token}` : '' },
            }
          );
          setMatchedCustomers(response.data || []);
        } catch (error) {
          console.error('Failed to fetch customers:', error);
          setMatchedCustomers([]);
        }
      } else {
        setMatchedCustomers([]);
      }
    };

    fetchCustomer();
  }, [customerQuery]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCancel = (e) => {
    e.preventDefault();
    setItems([]);
    setPaid(0);
    setFormData({
      payment_tell: '',
      delivery_address: '',
      delivery_id: '',
      delivery_fee: '',
      order_status: '',
      
    });
    setCustomerQuery('');
    setSelectedCustomer(null);
    setMatchedCustomers([]);
    formRef.current?.reset();
   
   
  };

  return (
    <div className="p-4 border shadow-sm rounded bg-white" style={{ minWidth: 400, maxWidth: 600, marginLeft: 'auto' }}>
   <div className="position-relative">
  <input
    type="text"
    className="form-control"
    placeholder="Search Customer"
    value={customerQuery}
    onChange={(e) => setCustomerQuery(e.target.value)}
  />

  {(matchedCustomers.length > 0 || customerQuery) && (
    <ul className="list-group position-absolute w-100 shadow-sm z-3" style={{ maxHeight: 200, overflowY: 'auto', top: '100%' }}>
      {matchedCustomers.map((customer) => (
        <li
          key={customer.id}
          className="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
          style={{ cursor: 'pointer' }}
          onClick={() => {
            setSelectedCustomer(customer);
            
            setCustomerQuery(customer.name);
            setMatchedCustomers([]);
          }}
        >
          <span>{customer.name}</span>
          <small className="text-muted">ID: {customer.id}</small>
        </li>
      ))}

      {matchedCustomers.length === 0 && customerQuery && !selectedCustomer && (
        <li className="list-group-item text-center text-primary" style={{ cursor: 'pointer' }} onClick={ handleOpenModal}>
          ➕ Add new customer
        </li>
      )}
    </ul>
  )}
</div>


  {/* new customer modal */}
    {showModal && (
  <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
    <div className="modal-dialog">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Add New Customer</h5>
          <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
        </div>
        <div className="modal-body">
          <div className="mb-3">
            <label className="form-label">Customer Name</label>
            <input
              type="text"
              className="form-control"
              value={newCustomer.name}
              onChange={(e) => setNewCustomer({ ...newCustomer, name: e.target.value })}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Phone Number</label>
            <input
              type="number"
              className="form-control"
              value={newCustomer.phone}
              onChange={(e) => setNewCustomer({ ...newCustomer, phone: e.target.value })}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Email</label>
            <input
              type="email"
              className="form-control"
              value={newCustomer.email}
              onChange={(e) => setNewCustomer({ ...newCustomer, email: e.target.value })}
            />
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancel</button>
          <button
            className="btn btn-primary"
            onClick={async () => {
             try {
  const req = { ...newCustomer, user_id };
  console.log("payload sending: ", req);

  const res = await axios.post(`${API_URL}/${ENDPOINTS.SYS}/create/register-pos_customer`, req, {
    headers: { Authorization: token ? `Bearer ${token}` : '' },
  });

  const { success, status, insertId, message } = res.data;

  if (status && success && insertId) {
    const fullName = `${newCustomer.name} (${newCustomer.phone})`;

    const customerData = {
      id: insertId,
      name: fullName,
    };

    setSelectedCustomer(customerData);       // Set customer for order
    setCustomerQuery(fullName);              // Fill input with name (phone)
    setShowModal(false);                     // Close modal

    alert(message || 'Customer added!');
  } else {
    alert(message || 'Customer registration failed!');
  }
} catch (error) {
  console.error('Error while registering customer:', error);
  alert('Failed to add customer');
}

            }}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
)}


      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">Products Added</h5>
        {items.length > 0 && (
          <button
            className="btn btn-sm btn-outline-danger"
            onClick={clearCart}
            title="Clear all items"
          >
            ✖ Clear all
          </button>
        )}
      </div>

      {items.length === 0 && <p className="text-muted">No items added.</p>}

      {items.map((item) => (
        <div
          key={item.ID}
          className="d-flex align-items-center justify-content-between mb-3 p-2 rounded hover-shadow"
          style={{ backgroundColor: '#f9f9f9' }}
        >
          <img
            src={
  item.Image
    ? `${API_URL}/${item.Image}`
    : `${API_URL}/${item.Image2}`
}
            alt={item.Name}
            style={{ width: 50, height: 50, objectFit: 'cover', borderRadius: 6, marginRight: 12 }}
          />
          <div className="flex-grow-1">
            <div className="fw-semibold">{item.Name}</div>
            <small className="text-muted">${Number(item.Price).toFixed(2)}</small>
          </div>
          <div className="d-flex align-items-center">
            <button
              className="btn btn-sm btn-outline-secondary"
              onClick={() => onUpdateQty(item.ID, item.qty - 1)}
              disabled={item.qty <= 1}
            >
              −
            </button>
            <input
              type="text"
              value={item.qty}
              readOnly
              className="form-control form-control-sm mx-1 text-center"
              style={{ width: 40 }}
            />
            <button
              className="btn btn-sm btn-outline-secondary"
              onClick={() => onUpdateQty(item.ID, item.qty + 1)}
            >
              +
            </button>
          </div>
          <div className="ms-3 d-flex align-items-center">
            <span className="fw-semibold">${(item.qty * item.Price).toFixed(2)}</span>
            <button
              className="btn btn-sm btn-link text-danger ms-2"
              onClick={() => onUpdateQty(item.ID, 0)}
            >
              ✕
            </button>
          </div>
        </div>
      ))}

      <hr />

      <form ref={formRef}>
        <div className="row">
          <div className="col-6 mb-3">
            <label htmlFor="payment_tell" className="form-label fw-semibold">Payment Tell</label>
            <input
              type="text"
              id="payment_tell"
              name="payment_tell"
              className="form-control"
              placeholder="Enter payment phone number"
              value={formData.payment_tell}
              onChange={handleInputChange}
            />
          </div>
          <div className="col-6 mb-3">
            <label htmlFor="delivery_address" className="form-label fw-semibold">Delivery Address</label>
            <input
              type="text"
              id="delivery_address"
              name="delivery_address"
              className="form-control"
              placeholder="Enter delivery address"
              value={formData.delivery_address}
              onChange={handleInputChange}
            />
          </div>
          <div className="col-6 mb-3">
            <label htmlFor="delivery_id" className="form-label fw-semibold">Delivery Man</label>
            <select
              id="delivery_id"
              name="delivery_id"
              className="form-select"
              value={formData.delivery_id}
              onChange={handleInputChange}
            >
              <option value="">Choose Delivery Man</option>
              {deliveryMen.map((man) => (
                <option key={man.id} value={man.id}>{man.name}</option>
              ))}
            </select>
          </div>
          <div className="col-6 mb-3">
            <label htmlFor="delivery_fee" className="form-label fw-semibold">Delivery Fee</label>
            <input
              type="number"
              id="delivery_fee"
              name="delivery_fee"
              className="form-control"
              placeholder="0.00"
              min={0}
              value={formData.delivery_fee>=0?  formData.delivery_fee : 0}
              onChange={handleInputChange}
            />
          </div>
          <div className="col-6 mb-3">
            <label htmlFor="discount_percentage" className="form-label fw-semibold">Discount Percantage %</label>
            <input
              type="number"
              id="discount_percantage"
              name="discount_percantage"
              className="form-control"
              placeholder="0.00"
              min={0}
              readOnly
             value={discountPercantage*100 || 0}
              onChange={handleInputChange}
            />
          </div>
          <div className="col-6 mb-3">
            <label htmlFor="order_status" className="form-label fw-semibold">Sales Status</label>
            <select
              id="order_status"
              name="order_status"
              className="form-select"
              value={formData.order_status}
              onChange={handleInputChange}
            >
              <option value="0">Lama Qaadin</option>
              <option value="1">Waa la Qaaday</option>
            </select>
          </div>
        </div>
      </form>

      <hr />

      <div className="d-flex justify-content-between mb-2">
        <span className="fw-semibold">Sub Total:</span>
        <strong>${subTotal.toFixed(2)}</strong>
      </div>
      <div className="d-flex justify-content-between mb-2">
        <span className="fw-semibold">Delivery Fee:</span>
        <strong>${delivery_fee.toFixed(2)>=0?delivery_fee.toFixed(2) :0.00}</strong>
      </div>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <span className="fw-semibold">Paid:</span>
        <input
          type="number"
          className="form-control"
          style={{ width: 110 }}
          value={(total-discountAmount).toFixed(2)}
          min={0}
          max={total}
          readOnly={true}
          step={0.01}
          onChange={(e) => setPaid(parseFloat(e.target.value) || 0)}
          aria-label="Paid amount"
        />
      </div>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <span className="fw-semibold">Discount:</span>
        <input
          type="number"
          className="form-control"
          style={{ width: 110 }}
          value={(total*discountPercantage).toFixed(2)}
          min={0}
          max={(total*discountPercantage)}
          readOnly={true}
          step={0.01}
          onChange={(e) => setPaid(parseFloat(e.target.value) || 0)}
          aria-label="Discount amount"
        />
      </div>
      <div className="mb-3">
  <label className="form-label fw-semibold">VAT Option:</label>
  <div>
    <div className="form-check form-check-inline">
      <input
        className="form-check-input"
        type="radio"
        name="vat_option"
        id="withVat"
        checked={withVat}
        onChange={() => setWithVat(true)}
      />
      <label className="form-check-label" htmlFor="withVat">With VAT</label>
    </div>
    <div className="form-check form-check-inline">
      <input
        className="form-check-input"
        type="radio"
        name="vat_option"
        id="withoutVat"
        checked={!withVat}
        onChange={() => setWithVat(false)}
      />
      <label className="form-check-label" htmlFor="withoutVat">Without VAT</label>
    </div>
  </div>
</div>

      <div className="d-flex justify-content-between mb-2">
        <span className="fw-semibold">VAT (5%):</span>
        <strong>${vat.toFixed(2)}</strong>
      </div>
      <div className="d-flex justify-content-between mb-3">
        <span className="fw-semibold">Total:</span>
        <strong>${total.toFixed(2)}</strong>
      </div>

      <div className="d-flex gap-2">
        <button className="btn btn-danger flex-fill" onClick={handleCancel}>
          Cancel
        </button>
        <button className="btn btn-success flex-fill" onClick={()=>handleSave(false)}>Save Only</button>
        <button className="btn btn-success flex-fill" onClick={()=>handleSave(true)}>Save & Print</button>
      </div>

      <style jsx>{`
        .hover-shadow:hover {
          box-shadow: 0 0 8px rgba(0, 0, 0, 0.12);
          background-color: #fff;
          transition: all 0.2s ease;
        }
      `}</style>
    </div>
  );
};

export default OrderPanel;
